import { formatCurrency } from '@/lib/currency';

/**
 * The months-2–3 intro price a trialing customer continues on, formatted for
 * copy (`£1`, `$1`). The Stripe catalogue's intro price for the customer's plan
 * (`billing.catalogue` on the billing-status response) wins, because it is what
 * the trial continues on in the sub's own market. The live plan amount is only
 * a fallback while trialing when the catalogue has no intro price: a mid-trial
 * Starter→Pro upgrade swaps the live item to the £79 Pro list price while the
 * trial carries on to the £1 intro phase, so the live amount can't be trusted
 * first.
 *
 * Null when neither is known — callers drop the price from their copy rather
 * than fall back to a hard-coded amount.
 */
export const introPriceLabel = (billing) => {
	if (!billing) return null;
	const intro = billing.plan ? billing.catalogue?.intro?.[billing.plan] : null;
	if (intro?.amount != null) return formatCurrency(intro.amount, intro.currency);
	return billing.isTrialing && billing.amount != null ? formatCurrency(billing.amount, billing.currency) : null;
};
